import ParentComponent from "../../lib/ParentComponent";

export default class Footer extends ParentComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return null;
  }
}
